var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-limit-message"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("participants.import.dataLimitMessage", { limit: _vm.limit })))])])}
var staticRenderFns = []

export { render, staticRenderFns }